import request from '../utils/request'
import { getToken } from '../utils/auth'

export function fetchCollectionList(filter) {
  return request({
    url: '/api/collections',
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function fetchCollection(id, filter) {
  return request({
    url: '/api/collections/' + id,
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function createCollection(data) {
  return request({
    url: '/api/collections',
    method: 'post',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function updateCollection(id, data) {
  return request({
    url: '/api/collections/' + id,
    method: 'patch',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function createCollectionLang(data) {
  return request({
    url: '/api/collection_langs',
    method: 'post',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function updateCollectionLang(id, data) {
  return request({
    url: '/api/collection_langs/' + id,
    method: 'patch',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function deleteCollection(id) {
  return request({
    url: '/api/collections/' + id,
    method: 'delete',
    params: {
      'access_token': getToken()
    }
  })
}

export function deleteCollectionLang(id) {
  return request({
    url: '/api/collection_langs/' + id,
    method: 'delete',
    params: {
      'access_token': getToken()
    }
  })
}

export function createCollectionFirebaseDynamicLink(id) {
  return request({
    url: `/api/collections/${id}/createFirebaseDynamicLink`,
    method: 'get',
    params: {
      'access_token': getToken()
    }
  })
}
